'use strict';

import get from 'lodash.get';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay/classic';

import DepositLink from 'dibs-buyer-deposit/exports/DepositLink';
import depositTracking from 'dibs-buyer-deposit/exports/depositTracking';
import DepositsAccepted from 'dibs-buyer-deposit/src/messages/DepositsAccepted';
import DepositShortCopy from 'dibs-buyer-deposit/src/messages/DepositShortCopy';

class DetailsDeposit extends React.Component {
    constructor(props) {
        super(props);
        this.handleModalClose = this.handleModalClose.bind(this);
        this.loadDepositModal = this.loadDepositModal.bind(this);

        this.state = {
            isModalOpen: false,
            DepositModalComponent: null,
        };
    }

    handleModalClose() {
        depositTracking.trackClose();
        this.setState({ isModalOpen: false });
    }

    loadDepositModal() {
        if (this.state.DepositModalComponent) {
            this.setState({ isModalOpen: true });
        } else {
            import(/* webpackChunkName: "DepositModal" */ '../Deposit/DepositModal')
                .then(moduleExport => {
                    this.setState(
                        {
                            DepositModalComponent: moduleExport.default,
                        },
                        () => {
                            this.setState({
                                isModalOpen: true,
                            });
                        }
                    );
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }

    render() {
        const { item, userId, relay } = this.props;

        const isDepositAvailable = get(item, 'isDepositAvailable');

        if (!userId || !item || !isDepositAvailable) {
            return null;
        }
        const { isModalOpen, DepositModalComponent } = this.state;
        const depositModalProps = {
            isOpen: isModalOpen,
            onClose: this.handleModalClose,
            buyerId: userId,
            itemId: item.serviceId,
            environment: relay.environment,
        };
        return (
            <div className="pdp-details-entry-content-container">
                <div className="pdp-details-entry-title-container">
                    <DepositsAccepted />
                </div>
                <div className="pdp-shipping-entry">
                    <DepositShortCopy />
                </div>
                <DepositLink onClick={this.loadDepositModal} />
                {DepositModalComponent && <DepositModalComponent {...depositModalProps} />}
            </div>
        );
    }
}

DetailsDeposit.propTypes = {
    userId: PropTypes.string,
    item: PropTypes.object,
    relay: PropTypes.object.isRequired,
};

export default Relay.createContainer(DetailsDeposit, {
    initialVariables: {
        userId: null,
    },
    fragments: {
        item: () => Relay.QL`
                fragment on Item {
                    serviceId
                    isDepositAvailable(buyerId: $userId)
                }
            `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/DetailsDeposit.jsx